import { useQuery, useQueryClient } from '@tanstack/react-query';
import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthFrame } from '@/components/AuthFrame';
import { authClient } from '@/lib/auth-client';
import { isUnauthorized } from '@/lib/errors';
import { meQuery } from '@/lib/session';

export const Route = createFileRoute('/setup-passkey')({
  beforeLoad: async ({ context }) => {
    try {
      const me = await context.queryClient.ensureQueryData(meQuery());
      if (me.hasPasskey) throw redirect({ to: '/tickets' });
    } catch (e) {
      if (isUnauthorized(e)) throw redirect({ to: '/login' });
      throw e;
    }
  },
  component: SetupPasskey
});

/** Mandatory before anything else (PLAN.md §4): approvals are signed with it. */
function SetupPasskey() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const me = useQuery(meQuery());
  const [failed, setFailed] = useState(false);
  const register = async () => {
    setFailed(false);
    const res = await authClient.passkey.addPasskey({ name: t('passkeySetup.defaultName') });
    if (res?.error) return setFailed(true);
    await queryClient.invalidateQueries({ queryKey: meQuery().queryKey });
    await navigate({ to: '/tickets', replace: true });
  };
  return (
    <AuthFrame title={t('passkeySetup.title')} lead={t('passkeySetup.lead')}>
      <p className="text-base-content/70 mb-4 text-sm">{t('passkeySetup.why')}</p>
      {me.data && <p className="text-base-content/60 mb-4 text-xs">{t('oauth.signedInAs', { name: me.data.name, email: me.data.email })}</p>}
      {failed && <p className="text-error mb-2 text-sm">{t('passkeySetup.failed')}</p>}
      <button type="button" className="btn btn-primary w-full" onClick={() => void register()}>
        {t('passkeySetup.register')}
      </button>
    </AuthFrame>
  );
}
